import CheckOutContainer from "../../Componant/Ecommerce/CheckOut";

const CheckOut = () => {
  return (
    <div className="page-body checkout">
      <CheckOutContainer />
    </div>
  );
};

export default CheckOut;
